import { Component, OnInit, OnChanges, Input, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators, FormArray } from '@angular/forms';
import { Router } from '@angular/router'
import { DataTableDirective } from 'angular-datatables';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { companyTask } from '../../../structure/compliance/companyTask';
import { CommonFunction } from '../../../helpers/commonFunction';
import { OnlyNumber } from '../../../helpers/OnlyNumber';
// import { LimittoMaxNumber } from '../../../helpers/LimittoMaxNumber';
// import { LimittoMinNumber } from '../../../helpers/LimittoMinNumber';


// import { GroupMasterService } from '../../../services/groupmaster.service';
import { TaskService } from '../../../services/task.service';
import { AlertComponent } from '../../../structure/alert/alert.component';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { Subject } from 'rxjs/Rx';
import { environment } from '../../../../environments/environment';
import { Location } from '@angular/common';
declare var $: any;
declare var jQuery: any;
declare var autosize: any
import * as _ from 'lodash';
import { LoaderService } from 'src/app/services/loader.service';



@Component({
  selector: 'app-edit-company-tasks',
  templateUrl: './edit-company-task.component.html',
  styleUrls: ['./edit-company-task.component.css']
})
export class EditCompanyTasksComponent implements OnInit {

  public environmentSettings: any;

  @ViewChild(DataTableDirective)
  dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  // The trigger needed to re-render the table
  dtTrigger: Subject<any> = new Subject();

  companytasklist: any[];
  //selectedCompanytasks: any[];
  selectedAll: any;
  meetingTypes: any[];
  meetingtypeId: string;
  meetingType: string;
  IsSelectedTasks: any;
  currentURL: any;

  selectedCompanytasks: companyTask[] = [];
  numList: Array<string> = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
  searcheFilteredDataTask: any[];
  disabledOnclick: boolean = false;

  constructor(private location: Location,private loaderService: LoaderService, private taskService: TaskService, private router: Router, private alert: AlertComponent, private commonFunction: CommonFunction) {
    this.currentURL = window.location.href;

  }


  selectAll() {
    if (this.searcheFilteredDataTask != undefined) {
      for (var i = 0; i < this.companytasklist.length; i++) {
        for (var j = 0; j < this.searcheFilteredDataTask.length; j++) {
          if (this.searcheFilteredDataTask[j] == this.companytasklist[i]._id) {
            this.companytasklist[i].SelectedTask = this.selectedAll;
            this.IsSelectedTasks = this.selectedAll;
          }
        }
      }
    }
    else {
      for (var i = 0; i < this.companytasklist.length; i++) {
        this.companytasklist[i].SelectedTask = this.selectedAll;
        this.IsSelectedTasks = this.selectedAll;
      }
    }
  }

  // selectAll() {
  //   for (var i = 0; i < this.companytasklist.length; i++) {
  //     this.companytasklist[i].SelectedTask = this.selectedAll;
  //     this.IsSelectedTasks = this.selectedAll;
  //   }
  // }

  checkIfAllSelected() {
    this.selectedAll = this.companytasklist.every(function (item: any) {
      return item.SelectedTask == true;
    })
  }

  checkselected(ev) {

    if (ev.target.checked == true) {
      this.IsSelectedTasks = true;
    }
    else {
      this.IsSelectedTasks = false;
    }

    var allSearchedSelected = true;
    if (_.size(this.companytasklist)) {
      for (var i = 0; i < this.companytasklist.length; i++) {
        for (var j = 0; j < this.searcheFilteredDataTask.length; j++) {
          if (this.searcheFilteredDataTask[j] == this.companytasklist[i]._id) {
            if (this.companytasklist[i].SelectedTasks) {
            } else {
              allSearchedSelected = false;
            }
          }
        }
      }
    }
    if (allSearchedSelected) {
      this.selectedAll = true;
    } else {
      this.selectedAll = false;
    }

  }

  getMeetingTypeList() {
    this.meetingTypes = [];

    this.taskService.getMeetingTypeList()
      .subscribe(meetingTypeList => {
        if (meetingTypeList.status == 0) {
          //this.meetingTypes = meetingTypeList.meetingTypeList;

          this.meetingTypes = this.commonFunction.sortByKey(meetingTypeList.meetingTypeList, 'MeetingType');;
        }
      })
  }

  getCompanyTaskListforEdit() {

    this.companytasklist = [];

    this.taskService.getPredefinedCompanyTasksListwithMeetingTypesandTriggerType()
      .subscribe(taskList => {
        if (taskList.status == 0) {

          // var tasksData = $(taskList.tasksDatalist).filter(function (i, n) { return parseInt(n.ReminderDays) });
          // this.companytasklist = this.commonFunction.sortByKey(tasksData, 'ProcessName');;
          var companytaskTable = $('#companytaskTable').DataTable({ destroy: true });
          companytaskTable.destroy();
          this.companytasklist = taskList.tasksDatalist;
          this.dtTrigger.next();
        }
      })
  }





  onlyNumber(ev) {
    var keyCode = window.event ? ev.keyCode : ev.which;
    //console.log(keyCode);
    //codes for 0-9
    if ((keyCode > 47 && keyCode < 58) || (keyCode == 109) || (keyCode > 95 && keyCode < 106) || (keyCode > 34 && keyCode < 41) || (keyCode == 16) || (keyCode == 46) || (keyCode == 9)) {

      if (((keyCode > 47 && keyCode < 58) || (keyCode > 95 && keyCode < 106)) && this.numList.indexOf(ev.key) == -1) {
        ev.preventDefault();
      }
      //restrict up to 2 digits
      if ((ev.target.value + ev.key).length > 5) {
        ev.preventDefault();
      }


    }
    else {
      if (keyCode != 0 && keyCode != 8 && keyCode != 13 && !ev.ctrlKey) {
        ev.preventDefault();
      }
    }
  }


  reset() {
    $('#resetConfirmation').modal('toggle');
  }

  resetFormData() {
    var companytaskTable = $('#companytaskTable').DataTable({ destroy: true });
    companytaskTable.destroy();
    $('#resetConfirmation').modal('toggle');
    this.getCompanyTaskListforEdit();
    this.getMeetingTypeList();
  }

  updateTasks() {
    this.disabledOnclick = true;
    // this.companytasklist;
    for (let result of this.companytasklist) {
      if (result.SelectedTask === true) {
        this.selectedCompanytasks.push(result);
      }

    }

    var companyTasks = {
      updateCompanyTasks: this.selectedCompanytasks
    }
    //this.taskService.updateCompanyTasks(companyTasks)

    this.taskService.updateCompanyTasks(companyTasks)
      .subscribe(result => {
        this.disabledOnclick = false;
        if (result.status == 0) {
          this.alert.success(result.message);
        }
        else {
          this.alert.error(result.message);
        }
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
        });


        this.getCompanyTaskListforEdit();
        this.getMeetingTypeList();
        this.selectedCompanytasks = [];
        this.IsSelectedTasks = false;
        this.selectedAll = false;
      });
  }


  ShowCompanyTasks() {
    this.ngOnInit();
    this.location.back(); // Navigate back to the previous page
  }

  refreshOnLoadTaskList() {
    var self = this;
    setTimeout(function () {
      console.log('refreshing data');
      self.refreshTaskList();
    }, 500)
  }


  refreshTaskList() {
    if (this.currentURL.includes('edit')) {
      var table = $('#companytaskTable').DataTable({ destroy: true });
      table.destroy();
      this.getCompanyTaskListforEdit();
    } else {
      var table = $('#companytaskTable').DataTable({ destroy: true });

      table.destroy();
      this.getCompanyTaskListforEdit();
    }
    $("#groupdropdown").val("null");

    this.selectedAll = false;
  }

  ngOnDestroy(): void {
    // Re-enable loader when navigating away from this component
    this.loaderService.enable();
  }


  ngOnInit() {
    this.loaderService.disable();
    this.environmentSettings = environment;

    //this.commonFunction.removeDataTableSaveStateKey("companytaskTable");

    this.selectedCompanytasks = [];
    this.IsSelectedTasks = false;
    this.getCompanyTaskListforEdit();
    this.getMeetingTypeList();
    this.dtOptions = {
      destroy: true,
      scrollY: "400px",
      scrollX: true,
      deferRender: true,
      scrollCollapse: true,
      stateDuration: -1,
      stateSave: true,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 8,
      search: true,
      order: [1, 'asc'],
      lengthMenu: [[5, 8, 10, 25, 50, 100, -1], [5, 8, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [0] }],

    };


    var self = this;
    setTimeout(function () {

      let table1 = $("#companytaskTable").DataTable();
      var searchedDataForSelectAll = [];

      table1.on('search.dt', function () {
        self.searcheFilteredDataTask = [];
        var tableData = $("#companytaskTable").DataTable().column(0, { search: 'applied' }).data();
        for (var i = 0; i < tableData.length; i++) {
          self.searcheFilteredDataTask.push(tableData[i])
        }

        var value = $('.dataTables_filter input').val();
        console.log("value,selectAll", value, self.selectedAll);

        if (value && self.selectedAll == true) {
          if (self.selectedAll == true) {
            self.selectedAll = false;

          }
          else {
            self.selectedAll = true;

          }
        }

        // var allSearchedSelected = false;
        // if (_.size(self.companytasklist)) {
        //   for (var i = 0; i < self.companytasklist.length; i++) {
        //     for (var j = 0; j < self.searcheFilteredDataTask.length; j++) {
        //       if (self.searcheFilteredDataTask[j] == self.companytasklist[i].ID) {
        //         if (self.companytasklist[i].SelectedTasks) {
        //         } else {
        //           allSearchedSelected = false;
        //         }
        //       }
        //     }
        //   }
        // }

        // if (allSearchedSelected) {
        //   self.selectedAll = true;
        // } else {
        //   self.selectedAll = false;
        // }


      });
    }, 3000);




  }


}
